import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { AppRoutes } from 'src/lib/routes';

const RedirectNotFound: React.FC<{ redirectUrl?: string }> = ({ redirectUrl }) => {
  const router = useRouter();

  useEffect(() => {
    router.push(redirectUrl || AppRoutes.notFoundRoute({}).toPath());
  }, []);

  return <></>;
};

export default RedirectNotFound;
